import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import PopoverBase from '../../helpers/PopoverBase/PopoverBase';
import styles from '@patternfly/react-styles/css/components/Tooltip/tooltip';
import '@patternfly/react-styles/css/components/Tooltip/tippy.css';
import '@patternfly/react-styles/css/components/Tooltip/tippy-overrides.css';
import { css } from '@patternfly/react-styles';
import { TooltipContent } from './TooltipContent';
import { KEY_CODES } from '../../helpers/constants';
import tooltipMaxWidth from '@patternfly/react-tokens/dist/js/c_tooltip_MaxWidth';
export var TooltipPosition;

(function (TooltipPosition) {
  TooltipPosition["auto"] = "auto";
  TooltipPosition["top"] = "top";
  TooltipPosition["bottom"] = "bottom";
  TooltipPosition["left"] = "left";
  TooltipPosition["right"] = "right";
})(TooltipPosition || (TooltipPosition = {}));

export var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).apply(this, arguments));

    _this.storeTippyInstance = function (tip) {
      tip.popperChildren.tooltip.classList.add(styles.tooltip);
      _this.tip = tip;
    };

    _this.handleEscKeyClick = function (event) {
      if (event.keyCode === KEY_CODES.ESCAPE_KEY && _this.tip.state.isVisible) {
        _this.tip.hide();
      }
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleEscKeyClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleEscKeyClick, false);
    }
  }, {
    key: "extendChildren",
    value: function extendChildren() {
      return React.cloneElement(this.props.children, {
        isAppLauncher: this.props.isAppLauncher
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          position = _a.position,
          trigger = _a.trigger,
          isContentLeftAligned = _a.isContentLeftAligned,
          isVisible = _a.isVisible,
          enableFlip = _a.enableFlip,
          children = _a.children,
          className = _a.className,
          bodyContent = _a.content,
          entryDelay = _a.entryDelay,
          exitDelay = _a.exitDelay,
          appendTo = _a.appendTo,
          zIndex = _a.zIndex,
          maxWidth = _a.maxWidth,
          isAppLauncher = _a.isAppLauncher,
          distance = _a.distance,
          aria = _a.aria,
          boundary = _a.boundary,
          flipBehavior = _a.flipBehavior,
          tippyProps = _a.tippyProps,
          id = _a.id,
          rest = __rest(_a, ["position", "trigger", "isContentLeftAligned", "isVisible", "enableFlip", "children", "className", "content", "entryDelay", "exitDelay", "appendTo", "zIndex", "maxWidth", "isAppLauncher", "distance", "aria", "boundary", "flipBehavior", "tippyProps", "id"]);

      var content = React.createElement("div", Object.assign({
        className: css(!enableFlip && (styles.modifiers[position] || styles.modifiers.top), className),
        role: "tooltip",
        id: id
      }, rest), React.createElement(TooltipContent, {
        isLeftAligned: isContentLeftAligned
      }, bodyContent));
      return React.createElement(PopoverBase, Object.assign({}, tippyProps, {
        arrow: true,
        aria: aria,
        onCreate: this.storeTippyInstance,
        maxWidth: maxWidth,
        zIndex: zIndex,
        appendTo: appendTo,
        content: content,
        lazy: true,
        theme: "pf-tooltip",
        placement: position,
        trigger: trigger,
        delay: [entryDelay, exitDelay],
        distance: distance,
        flip: enableFlip,
        flipBehavior: flipBehavior,
        boundary: boundary,
        isVisible: isVisible,
        popperOptions: {
          modifiers: {
            preventOverflow: {
              enabled: enableFlip
            },
            hide: {
              enabled: enableFlip
            }
          }
        }
      }), isAppLauncher ? this.extendChildren() : children);
    }
  }]);

  return Tooltip;
}(React.Component);
Tooltip.defaultProps = {
  position: 'top',
  trigger: 'mouseenter focus',
  isVisible: false,
  isContentLeftAligned: false,
  enableFlip: true,
  className: '',
  entryDelay: 500,
  exitDelay: 500,
  appendTo: function appendTo() {
    return document.body;
  },
  zIndex: 9999,
  maxWidth: tooltipMaxWidth && tooltipMaxWidth.value,
  isAppLauncher: false,
  distance: 15,
  aria: 'describedby',
  boundary: 'window',
  // For every initial starting position, there are 3 escape positions
  flipBehavior: ['top', 'right', 'bottom', 'left', 'top', 'right', 'bottom'],
  tippyProps: {},
  id: ''
};